var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form", { attrs: { "data-vv-scope": "data-group" } }, [
    _c("div", { staticClass: "row mb-5" }, [
      _c(
        "div",
        { staticClass: "col-md-6 mt-3" },
        [
          _c("vs-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            staticClass: "w-100",
            attrs: {
              label: "Código",
              maxlength: "40",
              name: "groupCode",
              danger: _vm.errors.has("data-group.groupCode"),
              "danger-text": _vm.errors.first("data-group.groupCode")
            },
            model: {
              value: _vm.editGroup.codigo,
              callback: function($$v) {
                _vm.$set(_vm.editGroup, "codigo", $$v)
              },
              expression: "editGroup.codigo"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-md-6 mt-3" },
        [
          _c("vs-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            staticClass: "w-100",
            attrs: {
              label: "Nombre de Grupo",
              maxlength: "250",
              name: "groupName",
              danger: _vm.errors.has("data-group.groupName"),
              "danger-text": _vm.errors.first("data-group.groupName")
            },
            model: {
              value: _vm.editGroup.nombre,
              callback: function($$v) {
                _vm.$set(_vm.editGroup, "nombre", $$v)
              },
              expression: "editGroup.nombre"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-md-12 mt-3" },
        [
          _c("vs-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            staticClass: "w-100",
            attrs: {
              label: "Descripción de Grupo",
              maxlength: "250",
              name: "groupDescription",
              danger: _vm.errors.has("data-group.groupDescription"),
              "danger-text": _vm.errors.first("data-group.groupDescription")
            },
            model: {
              value: _vm.editGroup.descripcion,
              callback: function($$v) {
                _vm.$set(_vm.editGroup, "descripcion", $$v)
              },
              expression: "editGroup.descripcion"
            }
          })
        ],
        1
      ),
      this.action === "add"
        ? _c("div", { staticClass: "col-md-11 chip-custom" }, [
            _vm._v(
              " Este grupo será creado como subgrupo de " +
                _vm._s(_vm.editGroup.padreNombre) +
                " "
            )
          ])
        : _vm._e(),
      _c("div", { staticClass: "col-md-12 mt-3" }, [
        _c(
          "div",
          { staticStyle: { float: "right" } },
          [
            _c(
              "vs-button",
              {
                staticClass: "action",
                attrs: { color: "primary", type: "border", icon: "save" },
                on: {
                  click: function($event) {
                    return _vm.saveChanges()
                  }
                }
              },
              [_vm._v(" Guardar ")]
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }